module.exports = __webpack_public_path__ + "media/dobry_wzor/logo_dobry wzor_2019 -77a96800.jpg";